import { Button, Select, Switch, Input, Tooltip } from "antd";
import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../atoms/CustomIcons";
import { useState } from "react";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      search_text: string | undefined;
      deactivated: boolean | undefined;
      company: string | undefined;
      position: string | undefined;
      language: string | undefined;
      status: string | undefined;
    }>
  >;
  filters: {
    search_text: string | undefined;
    deactivated: boolean | undefined;
    company: string | undefined;
    position: string | undefined;
    language: string | undefined;
    status: string | undefined;
  };
  deactivated: boolean;
  isDeactivated: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Filters(props: FilterProps) {
  const { setFilters, filters, isDeactivated, deactivated } = props;
  const [showFilters, setShowFilters] = useState(false);

  const onChange = (checked: boolean) => {
    isDeactivated(checked);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "deactivated",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: undefined,
      }));
    }
  };

  const clearFilters = () => {
    setFilters({
      search_text: undefined,
      deactivated: undefined,
      company: undefined,
      position: undefined,
      status: undefined,
      language: undefined,
    });
    isDeactivated(false);
  };
  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search team member"
            value={filters?.search_text}
            allowClear
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                search_text: e.target.value,
              }))
            }
          />
        </div>
        <div className="filterToggle">
          <Button
            icon={<FilterIcon />}
            className={`outlined-btn ${showFilters && "show_filters"} ${
              deactivated && "archived"
            }`}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters{" "}
            <div className="filter_icon">
              <SelectArrow />
            </div>
          </Button>
        </div>
        <div className="filterDownload">
          <Button icon={<DownloadIcon />} />
        </div>
      </div>
      {showFilters && (
        <div className="filtersBottom">
          <div className="btmLeft">
            <div className="filterBox">
              <Tooltip title="Role" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  allowClear
                  showSearch
                  placeholder="Role"
                  options={[
                    { value: "super_admin", label: "Super Admin" },
                    { value: "client_manager", label: "Client Manager" },
                  ]}
                  value={filters?.position}
                  onChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      position: value,
                    }))
                  }
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <Tooltip title="Status" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  allowClear
                  showSearch
                  placeholder="Status"
                  options={[
                    { value: "active", label: "Active" },
                    { value: "deactivated", label: "Deactivated" },
                  ]}
                  value={filters?.status}
                  onChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      status: value,
                    }))
                  }
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onChange} checked={deactivated} />
                {deactivated ? "Hide deactivated" : "Show deactivated"}
              </div>
            </div>
          </div>

          <div className="btmRight">
            <Button
              className="outlined-btn"
              onClick={clearFilters}
              disabled={
                !filters.search_text &&
                !filters.position &&
                !filters.status &&
                !deactivated
                  ? true
                  : false
              }
            >
              Clear filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
